import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false,
})
export class ProgressBarComponent {
    @Input() public progress: number = 0; // Процент от 0 до 100
}
